import { render, staticRenderFns } from "./EditPKBPage.vue?vue&type=template&id=0e0f1b2d&"
import script from "./EditPKBPage.vue?vue&type=script&lang=js&"
export * from "./EditPKBPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports